// A failed write in words, in one place: the server's refusal of a Viewer's write (403
// `feature_forbidden`, `readOnlyRefusal`) as read-only access, everything else as before — the
// platform's `crudErrorText` for a CRUD save, the error's own message elsewhere.

import { READ_ONLY_REFUSAL, readOnlyRefusal } from "@app/shared";
import { crudErrorText } from "@axny/platform-ui";
import { notify } from "./message";
import { VIEW_ONLY_TOAST_MS } from "./can-write";

/** A CRUD save's failure: the field errors or the server's words (`crudErrorText`), a Viewer's refusal plainly. */
export const writeErrorText = (e: unknown, labels?: Readonly<Record<string, string>>) =>
  readOnlyRefusal(e) ? READ_ONLY_REFUSAL : crudErrorText(e, labels);

/** Any other failure: its own message, a Viewer's refusal plainly. */
export const errorWords = (e: unknown) =>
  readOnlyRefusal(e) ? READ_ONLY_REFUSAL : e instanceof Error ? e.message : String(e);

/**
 * A write the server refused as read-only (a stale tab): the small toast, never the red message.
 * True when it was one — the caller says nothing more; any other failure keeps its red message.
 */
export function toastIfReadOnly(e: unknown): boolean {
  if (!readOnlyRefusal(e)) return false;
  notify(READ_ONLY_REFUSAL, undefined, VIEW_ONLY_TOAST_MS);
  return true;
}
